<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">{{words.scandocument}}
        <Tooltip content="扫描文件保留15天过期自动清除!">
          <Icon type="ios-alert" size='20' />
        </Tooltip>
      </p>
      <!-- <div class="btn-box">
        <Button size="large" class="primary" type="primary">
          添加文件
          <Icon type="md-add"/>
        </Button>
      </div>-->
    </div>
    <div class="table-box">
      <Table size="large" :loading="loading" :columns="columns" stripe :data="data" :height="700"></Table>
    </div>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total"/>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      loading: false,
      columns: [
        {
          title: "文件名",
          key: "file_name",
          width: 240,
          className: "table-header-col"
        },
        {
          title: "大小",
          key: "file_size",
          className: "table-header-col",
          render: (h, data) => {
            let size = data.row.file_size / 1024,
              sizeS = "";
            if (size >= 1024) sizeS = size / 1024 + "MB";
            else sizeS = size / 1024 + "MB";
            return h("span", size >= 1024 ? size / 1024 + "MB" : size + "KB");
          }
        },
        {
          title: "页数",
          key: "pages",
          className: "table-header-col"
        },
        {
          title: "提交时间",
          key: "create_time",
          className: "table-header-col",
          render: (h, data) => {
            console.log(data.row.create_time);
            return h("span", this.$moment(new Date(data.row.create_time)));
          },
          width: 200
        },
        {
          title: "提交方式",
          key: "mode",
          className: "table-header-col"
        },
        {
          title: "操作",
          key: "oper",
          className: "table-header-col",
          render: (h, data) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    type: "success"
                  },
                  on: {
                    click: () => {
                      console.log('123333',data.row);
                      this.down(data.row);
                    }
                  }
                },
                "预览"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error"
                  },
                  on: {
                    click: () => {
                      this.del(data.row._index, data.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      data: [],
      page: {
        p: 0,
        l: 10,
        is_pc: 1,
        type: 3,
        status: true,
        is_scan: 1
      },
      total: 0
    };
  },
  mounted() {
    this.columns = [
      {
        title: this.words.FilName,
        key: "file_name",
        width: 240,
        className: "table-header-col"
      },
      {
        title: this.words.PrintSize,
        key: "file_size",
        className: "table-header-col",
        render: (h, data) => {
          let size = data.row.file_size / 1024;
          return h(
            "span",
            size >= 1024
              ? (size / 1024).toFixed(2) + "MB"
              : size.toFixed(2) + "KB"
          );
        }
      },
      {
        title: this.words.PrintPage,
        key: "pages",
        className: "table-header-col"
      },
      {
        title: this.words.PrintDate,
        key: "create_time",
        className: "table-header-col",
        render: (h, data) => {
          return h("span", this.$moment(new Date(data.row.create_time)));
        },
        width: 200
      },
    
      {
        title: this.words.Operate,
        key: "oper",
        className: "table-header-col",
        render: (h, data) => {
          return h("div", {}, [
            h(
              "Button",
              {
                props: {
                  type: data.row.file_path ? "success" : 'disabled',
                },
                style:{
                  backgroundColor:!data.row.file_path ? "#ccc" : '',
                  color:!data.row.file_path ? "#fff" : '',
                },
                on: {
                  click: () => {
                    console.log(data.row);
                    this.down(data.row);
                  }
                }
              },
              this.words.Download
            ),
            h(
              "Button",
              {
                props: {
                  type: "error"
                },
                on: {
                  click: () => {
                    this.del(data.row._index, data.row.id);
                  }
                }
              },
              this.words.Delete
            )
          ]);
        }
      }
    ];
    this.getList();
  },
  methods: {
    ...mapActions(["GetJobList", "DelJob"]),
    Banner() {
      this.getBannber().then(res => {
        console.log(res);
      });
    },
    pageChange(p) {
     this.page.p = p - 1;
      this.getList();
    },
    sizeChange(e) {
      this.page.l = e
      this.getList();
    },
    getList() {
      this.loading = true;
      this.GetJobList(this.page).then(res => {
        this.data = res.data;
        this.total = res.total;
        this.loading = false;
      });
    },
    del(index, id) {
      this.DelJob({ id }).then(res => {
        if (res.code === 1) {
          this.getList();
        }
      });
    },
    down(item) {
      if(!item.file_path){
        this.$Message.error('扫描作业只保留15天，现已无法下载！');
        return false;
      }
      if(!item.ip_address){
        this.$Message.error('请前往邮箱或共享服务器下载'); 
        return false;
      }
      item.file_path = item.file_path.replace(/\\/g,"/")
      let path =
        "https://" +
        item.ip_address +
        "/FileOut/getFile?type=open&scan=scan&path=" +
        item.file_path;
      window.open(path);
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>